import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
/** @internal The context backing {@link useArtis}. Provided by `<ArtisAppProvider>`. */
export const ArtisContext = createContext(undefined);
/** @internal The bare context provider. Consumers mount `<ArtisAppProvider>`, which wraps this. */
export const ArtisProvider = ({ value, children }) => (_jsx(ArtisContext.Provider, { value: value, children: children }));
//# sourceMappingURL=provider.js.map